import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { watertownConfig } from "./data";

export default function WatertownPage() {
  return <CityPageTemplate config={watertownConfig} />;
}